<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text-A"><a href="#/Book1/cover">SWORDS AND DEVILTRY</a></p>
<p class="toc-text"><a href="#/Book1/section1#a1">I Induction</a></p>
<p class="toc-text"><a href="#/Book1/section1#a2">II The Snow Women</a></p>
<p class="toc-text"><a href="#/Book1/section1#a3">III The Unholy Grail</a></p>
<p class="toc-text"><a href="#/Book1/section1#a4">IV Ill Met in Lankhmar</a></p>
<p class="toc-text-A1"><span href="#/Book2/cover" title="Link target outside of Sample">SWORDS AGAINST DEATH</span></p>
<p class="toc-text"><span href="#/Book2/section2" title="Link target outside of Sample">Chapter I – The Circle Curse</span></p>
<p class="toc-text"><span href="#/Book2/section3" title="Link target outside of Sample">Chapter II – The Jewels in the Forest</span></p>
<p class="toc-text"><span href="#/Book2/section4" title="Link target outside of Sample">Chapter III – Thieves’ House</span></p>
<p class="toc-text"><span href="#/Book2/section5" title="Link target outside of Sample">Chapter IV – The Bleak Store</span></p>
<p class="toc-text"><span href="#/Book2/section6" title="Link target outside of Sample">Chapter V – The Howling Tower</span></p>
<p class="toc-text"><span href="#/Book2/section7" title="Link target outside of Sample">Chapter VI – The Sunken Land</span></p>
<p class="toc-text"><span href="#/Book2/section8" title="Link target outside of Sample">Chapter VII – The Seven Black Priests</span></p>
<p class="toc-text"><span href="#/Book2/section9" title="Link target outside of Sample">Chapter VIII – Claws from the Night</span></p>
<p class="toc-text"><span href="#/Book2/section10" title="Link target outside of Sample">Chapter IX – The Prince of Pain-ease</span></p>
<p class="toc-text"><span href="#/Book2/section11" title="Link target outside of Sample">Chapter X – Bazaar of the Bizarre</span></p>
<p class="toc-text-A1"><span href="#/Book3/cover" title="Link target outside of Sample">SWORDS IN THE MIST</span></p>
<p class="toc-text"><span href="#/Book3/section2" title="Link target outside of Sample">Chapter I – The Cloud of Hate</span></p>
<p class="toc-text"><span href="#/Book3/section3" title="Link target outside of Sample">Chapter II – Lean Times in Lankhmar</span></p>
<p class="toc-text"><span href="#/Book3/section4" title="Link target outside of Sample">Chapter III – Their Mistress, The Sea</span></p>
<p class="toc-text"><span href="#/Book3/section5" title="Link target outside of Sample">Chapter IV – When the Sea-King’s Away</span></p>
<p class="toc-text"><span href="#/Book3/section6" title="Link target outside of Sample">Chapter V – The Wrong Branch</span></p>
<p class="toc-text"><span href="#/Book3/section7" title="Link target outside of Sample">Chapter VI – Adept’s Gambit</span></p>
<p class="toc-text"><span href="#/preview" title="Link target outside of Sample">Preview: <i>Swords Against Wizardry</i></span></p>
<p class="toc-text"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?28a148c9